export default __webpack_public_path__ + "static/media/CnapsLogo.73772b27.svg";